(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[809],{

/***/ 7018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends2 = __webpack_require__(88239);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.Z = function (ComposedComponent) {
  var _desc, _value, _class;

  return _class = function (_React$Component) {
    (0, _inherits3.default)(WithScroll, _React$Component);

    function WithScroll(props) {
      (0, _classCallCheck3.default)(this, WithScroll);

      var _this = (0, _possibleConstructorReturn3.default)(this, (WithScroll.__proto__ || Object.getPrototypeOf(WithScroll)).call(this, props));

      _this.state = _this.calculateScroll();
      _this.debouncedHandle = (0, _throttle2.default)(_this.setNewState, 50);
      return _this;
    }

    (0, _createClass3.default)(WithScroll, [{
      key: 'calculateScroll',
      value: function calculateScroll() {
        if (typeof window === 'undefined') return { scrollX: 0, scrollY: 0 };
        var _window = window,
            scrollX = _window.scrollX,
            scrollY = _window.scrollY;

        return { scrollX: scrollX, scrollY: scrollY };
      }
    }, {
      key: 'setNewState',
      value: function setNewState() {
        this.setState(this.calculateScroll());
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('scroll', this.debouncedHandle);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.debouncedHandle);
      }
    }, {
      key: 'render',
      value: function render() {
        // console.log('rerendering scroll', this.state)
        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, this.state));
      }
    }]);
    return WithScroll;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'setNewState', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setNewState'), _class.prototype)), _class;
};

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = __webpack_require__(88572);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _throttle = __webpack_require__(23493);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 44908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 13219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_fragments_products_productListInformation_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2779);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment orderCategory on Category {\n    _id\n    name\n    products {\n      _id\n      categories {\n        _id\n        internalName\n      }\n      modifiers {\n        _id\n        optional\n      }\n      ...productListInformation\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject(), _data_fragments_products_productListInformation_main__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z));


/***/ }),

/***/ 74207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getOutOfStockProductsInListQuery; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getOutOfStockProductsInList(\n    $websiteId: ID\n    $productsIds: [ID]\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    outOfStockIds: outOfStockProductsInList(\n      websiteId: $websiteId\n      productsIds: $productsIds\n      storeId: $storeId\n      deliverAt: $deliverAt\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getOutOfStockProductsInListQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 87714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ exactSearch; }
/* harmony export */ });
var hasAtLeastNumbers = function(phrase) {
    var numbers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    var re = /\d/g;
    var repeats = ((phrase || "").match(re) || []).length;
    return repeats >= numbers;
};
var hashHyphens = function(phrase) {
    var indexOfHyphen = phrase.indexOf("-");
    return indexOfHyphen !== -1;
};
function exactSearch(phrase) {
    return hasAtLeastNumbers(phrase) || hashHyphens(phrase);
};


/***/ }),

/***/ 13505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExperiment; }
/* harmony export */ });
/* unused harmony export withExperiment */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32321);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var _useUserId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77883);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getUserExperimentBranch(\n        $experimentId: String!\n        $deviceId: String!\n        $websiteId: String\n        $userId: String\n        $countryCode: String\n      ) {\n        getUserExperimentBranch(\n          experimentId: $experimentId\n          websiteId: $websiteId\n          userId: $userId\n          deviceId: $deviceId\n          countryCode: $countryCode\n        ) {\n          branchName\n          createdAt\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useExperiment(experimentId) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _partial = ref.partial, partial = _partial === void 0 ? true : _partial;
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().website;
    var deviceId = (0,_helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var userId = (0,_useUserId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    // Hacky trick to disable apollo validation since this uses the experiments client
    var getUserExperimentBranch = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useApolloQuery */ .Zu)({
        errorPolicy: "ignore",
        clientName: "experiments",
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: {
            experimentId: experimentId,
            websiteId: website === null || website === void 0 ? void 0 : website._id,
            userId: userId,
            deviceId: deviceId,
            countryCode: website === null || website === void 0 ? void 0 : website.countryCode
        },
        partial: partial,
        fetchPolicy: "cache-first"
    }).getUserExperimentBranch;
    return getUserExperimentBranch === null || getUserExperimentBranch === void 0 ? void 0 : getUserExperimentBranch.branchName;
};
var withExperiment = function(experimentId, Component) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        var branchName = useExperiment(experimentId);
        return /*#__PURE__*/ _jsx(Component, _objectSpread({}, props, {
            experimentBranchName: branchName
        }));
    };
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteLoyaltyConfig; }
/* harmony export */ });
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getActiveLoyaltyProgramConfig($websiteId: ID) {\n        loyaltyProgramConfig(websiteId: $websiteId) {\n          _id\n          name\n          active\n          maxRedeemAmount\n          minRedeemAmount\n          accumulationRate\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useWebsiteLoyaltyConfig(websiteId) {
    var ref = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId
    }), loyaltyProgramConfig = ref.loyaltyProgramConfig, loading = ref.loading, error = ref.error;
    return {
        loyaltyProgramConfig: loyaltyProgramConfig,
        loading: loading,
        error: error
    };
};


/***/ }),

/***/ 17854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebsiteCoinsImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56036);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function WebsiteCoinsImage(param) {
    var _customStyle = param.customStyle, customStyle = _customStyle === void 0 ? null : _customStyle;
    var style = (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center mr-1 w-5 relative justify-center", customStyle);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            src: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FM6Wexw4yRsJDacfMJ-website-coins.svg",
            alt: "WebsiteCoinsLogo",
            title: "websiteCoinsLogo",
            height: 20,
            width: 20,
            objectFit: "contain",
            layout: "fill"
        })
    });
};


/***/ }),

/***/ 79354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShouldUseLoyaltyV2; }
/* harmony export */ });
/* harmony import */ var _hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13505);

function useShouldUseLoyaltyV2() {
    var branchName = (0,_hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("loyalty-justo");
    return branchName === "show";
};


/***/ }),

/***/ 69475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5434);
/* harmony import */ var _helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63601);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80449);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);




function LoginButton() {
    var loginViaAuth = (0,_helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__/* .useLoginViaAuthWindow */ .l)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        onClick: function() {
            return loginViaAuth();
        },
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().menuText),
        children: [
            "Iniciar sesi\xf3n ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdLogin */ .HOZ, {})
        ]
    });
};


/***/ }),

/***/ 12656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ filterUnavailableProducts; },
/* harmony export */   "Z": function() { return /* binding */ Category; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _data_fragments_categories_orderCategory_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13219);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6535);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59540);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






//TODO: this logic should be sent to backend when hideNotAvailableProducts option is divided into to functionalities
var filterUnavailableProducts = function(hideNotAvailableProducts) {
    return function(product) {
        if (hideNotAvailableProducts && product.isOutOfStock) {
            return false;
        }
        if (!product.availabilityAt) return false;
        if (product.availabilityAt.notAvailableMessage) return true;
        return !!product.availabilityAt.available;
    };
};
var _Component;
var Category = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Category, _superClass);
    var _super = _createSuper(Category);
    function Category() {
        _classCallCheck(this, Category);
        return _super.apply(this, arguments);
    }
    var _proto = Category.prototype;
    _proto.getProducts = function getProducts() {
        var filterUnavailableProductsFn = filterUnavailableProducts(this.props.hideNotAvailableProducts);
        var productList = this.props.category.products.filter(filterUnavailableProductsFn);
        if (this.props.sorting) {
            if (this.props.sorting.type === "price") {
                productList = lodash_orderBy__WEBPACK_IMPORTED_MODULE_3___default()(productList, function(product) {
                    return product.availabilityAt.finalPrice;
                }, [
                    this.props.sorting.order
                ]);
            }
            if (this.props.sorting.type === "name") {
                productList = lodash_orderBy__WEBPACK_IMPORTED_MODULE_3___default()(productList, [
                    "name"
                ], [
                    this.props.sorting.order
                ]);
            }
            if (this.props.sorting.type === "timesPurchased") {
                productList = lodash_orderBy__WEBPACK_IMPORTED_MODULE_3___default()(productList, [
                    "timesPurchased"
                ], [
                    this.props.sorting.order
                ]);
            }
        }
        return productList;
    };
    _proto.renderProducts = function renderProducts() {
        var _this = this;
        var className = this.props.productsLayout === "compact" ? ({
            mobile: "col-xs-6",
            v1: "col-xs-6 col-md-3",
            v2: "col-xs-3 col-md-2"
        })[this.props.layout] : ({
            mobile: "col-xs-12",
            v1: "col-xs-12 col-md-6",
            v2: "col-xs-6 col-md-4"
        })[this.props.layout];
        className += " menuProductCol";
        return this.getProducts().map(function(product) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Product__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    productsLayout: _this.props.productsLayout,
                    productCardDesign: _this.props.productCardDesign,
                    hidePrice: _this.props.hidePrice,
                    // @ts-expect-error ts-migrate(2739) FIXME: Type 'orderCategory_products' is missing the follo... Remove this comment to see the full error message
                    product: product,
                    menuId: _this.props.menuId
                })
            }, product._id);
        });
    };
    _proto.render = function render() {
        var category = this.props.category;
        if (this.getProducts().length === 0) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
                id: "t111_".concat(category._id),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().name),
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().products),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: this.renderProducts()
                        })
                    })
                ]
            })
        });
    };
    return Category;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
Category.fragment = _data_fragments_categories_orderCategory_main__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;



/***/ }),

/***/ 98784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WebsiteCoins; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useUserId.ts
var useUserId = __webpack_require__(77883);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/hooks/useWebsiteLoyaltyConfig.main.ts
var useWebsiteLoyaltyConfig_main = __webpack_require__(87529);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/sections/useShouldUseLoyaltyV2.ts
var useShouldUseLoyaltyV2 = __webpack_require__(79354);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage.tsx
var WebsiteCoinsImage = __webpack_require__(17854);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/LoginButton.tsx
var LoginButton = __webpack_require__(69475);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/useWebsiteCoinsBalanceNavBar.main.tsx
var useWebsiteCoinsBalanceNavBar_main = __webpack_require__(22622);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/WebsiteCoin.tsx




function WebsiteCoin(param) {
    var websiteId = param.websiteId, config = param.config;
    var me = (0,useWebsiteCoinsBalanceNavBar_main/* default */.Z)(websiteId).me;
    if (!(me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) && (me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) !== 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex bg-red-600 py-5 px-7 rounded-md text-white justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoinsImage/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/justoloyalty",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-bold text-lg ml-2 text-white cursor-pointer",
                    children: [
                        "Tienes ",
                        me.websiteCoinsBalance,
                        " ",
                        config.name
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/index.tsx








function WebsiteCoins() {
    var showJustoLoyaltyV2 = (0,useShouldUseLoyaltyV2/* default */.Z)();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var userId = (0,useUserId/* default */.Z)();
    var ref = (0,useWebsiteLoyaltyConfig_main/* default */.Z)(websiteId), config = ref.loyaltyProgramConfig;
    if (!showJustoLoyaltyV2) return null;
    if (!(config === null || config === void 0 ? void 0 : config.active) || !websiteId) return null;
    if (!userId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col sm:flex-row bg-red-600 py-5 px-7 rounded-md relative w-full max-w-3xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoinsImage/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col text-white ml-2 mr-7 mb-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Comienza a acumular tus ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: config.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs font-medium",
                        children: "Inicia sesi\xf3n y acumula puntos con cada compra y canjealos por descuento en tu pedido"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mx-4 text-white bg-black rounded font-medium text-xs px-5 py-2 w-60 h-10 justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton/* default */.Z, {})
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full max-w-4xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoin, {
            config: config,
            websiteId: websiteId
        })
    });
};


/***/ }),

/***/ 22622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteCoinsBalanceNavBar; }
/* harmony export */ });
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteCoinsBalance($websiteId: ID) {\n        me {\n          _id\n          websiteCoinsBalance(websiteId: $websiteId)\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useWebsiteCoinsBalanceNavBar(websiteId) {
    var ref = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId,
        fetchPolicy: "cache-first"
    }), me = ref.me, loading = ref.loading, error = ref.error;
    return {
        me: me,
        loading: loading,
        error: error
    };
};


/***/ }),

/***/ 68156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/hasWebpSupport.ts
var hasWebpSupport = __webpack_require__(6909);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/helpers/misc/getOrderPath.ts
var getOrderPath = __webpack_require__(81820);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
// EXTERNAL MODULE: ./src/helpers/misc/scrollTo.ts
var scrollTo = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withScroll.js
var withScroll = __webpack_require__(7018);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx
var StoreName = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Bar/index.tsx
var Bar = __webpack_require__(98812);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/BrandBar/index.tsx
var BrandBar = __webpack_require__(10238);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx + 1 modules
var Brands = __webpack_require__(51888);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/index.tsx + 1 modules
var Categories = __webpack_require__(7078);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/index.tsx
var Category = __webpack_require__(12656);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Filters/index.tsx
var Filters = __webpack_require__(82544);
// EXTERNAL MODULE: ./src/helpers/misc/exactSearch.ts
var exactSearch = __webpack_require__(87714);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/getProducts.ts

function getProducts(products, filter, Fuse, sort) {
    var exact = (0,exactSearch/* default */.Z)(filter);
    var fuse = new Fuse(products, {
        fieldNormWeight: 1,
        keys: [
            {
                name: "name",
                weight: 1
            },
            {
                name: "nicknames",
                weight: 1
            },
            {
                name: "description",
                weight: 0.5
            }
        ],
        threshold: exact ? 0 : 0.45
    });
    var productList = fuse.search(filter).map(function(product) {
        return product.item;
    });
    return productList;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/NoBrandDivider/index.tsx
var NoBrandDivider = __webpack_require__(26642);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx + 31 modules
var SelectProduct = __webpack_require__(48791);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/index.tsx + 1 modules
var WebsiteCoins = __webpack_require__(98784);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/styles.module.css
var styles_module = __webpack_require__(31616);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


























var _class;
var _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    typeof ProductsContentProps === "undefined" ? Object : ProductsContentProps
]), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function);
var ProductsContent = _class = (0,withScroll/* default */.Z)(_class = _dec1(_class = _dec((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ProductsContent, _Component);
    var _super = _createSuper(ProductsContent);
    function ProductsContent(props) {
        _classCallCheck(this, ProductsContent);
        var _this;
        _this = _super.call(this, props);
        _this.lastProductId = null;
        _this.categoriesRefs = {};
        _this.state = {
            scrollOffset: 0,
            filter: "",
            sorting: null,
            lastScroll: null,
            searchProducts: []
        };
        var productId = props.router.query.productId;
        if (productId) {
            _this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        return _this;
    }
    var _proto = ProductsContent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var scrollCategorySlug = this.props.router.query.categoria;
        var search = this.props.router.query.search;
        if (scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        if (search) {
            this.setState({
                filter: search
            });
            this.memoizeProducts();
        }
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
        // Avoid rerendering everytime the scroll changes
        if (this.props.scrollY !== nextProps.scrollY) {
            if (this.shouldUpdateActiveCategory(nextProps.scrollY)) {
                return true;
            }
            return false;
        }
        return true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var ref;
        this.setScrollToId();
        this.checkActiveCategory(this.props.scrollY);
        this.scrollTo();
        var scrollCategorySlug = this.props.router.query.categoria;
        if (scrollCategorySlug && this.state.lastScroll !== scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        var search = this.props.router.query.search;
        if (search && search !== prevProps.router.query.search) {
            this.setState({
                filter: search
            });
        }
        // If either the query changed or the previous memoization attempt failed, memoize the products
        if (search && (search !== prevProps.router.query.search || !((ref = this.state.searchProducts) === null || ref === void 0 ? void 0 : ref.length))) {
            this.memoizeProducts();
        }
    };
    _proto.setScrollOnClick = function setScrollOnClick(category) {
        this.setState({
            scrollToSlug: category,
            lastScroll: category
        });
    };
    _proto.setScrollToId = function setScrollToId() {
        var categories = this.props.categories;
        var _state = this.state, scrollToSlug = _state.scrollToSlug, scrollTo1 = _state.scrollTo;
        if (!categories) return;
        if (!scrollToSlug || scrollTo1) return;
        var clean = function(text) {
            return text.toLowerCase().replace(/ /g, "-");
        };
        var scrollCategory = categories.items.find(function(item) {
            return slugify_default()(clean(item.name)) === clean(scrollToSlug);
        });
        if (scrollCategory) {
            this.setState({
                scrollTo: scrollCategory._id,
                scrollToSlug: null
            });
        }
    };
    _proto.getVisibleCategories = function getVisibleCategories() {
        if (!this.props.categories) return [];
        return this.props.categories.items.filter(function(category) {
            return category.products.length;
        });
    };
    _proto.getCategoriesBarOffset = function getCategoriesBarOffset() {
        if (this.props.layout === "v1") {
            return 70;
        } else {
            return 70 + 50;
        }
    };
    _proto.scrollTo = function scrollTo2() {
        if (!this.props.categories) return;
        if (!this.state.scrollTo) return;
        if (!this.categoriesRefs[this.state.scrollTo]) {
            console.log("scroll to category not found");
            return;
        }
        if (!this.categoriesRefs[this.state.scrollTo].offsetTop) {
            var _this = this;
            console.log("scroll to category not mounted, trying again");
            setTimeout(function() {
                return _this.scrollTo();
            }, 400);
            return;
        }
        var top = this.categoriesRefs[this.state.scrollTo].offsetTop - this.getCategoriesBarOffset() - this.state.scrollOffset;
        (0,scrollTo/* default */.Z)({
            top: top
        });
        this.setState({
            scrollTo: null
        });
    };
    _proto.shouldUpdateActiveCategory = function shouldUpdateActiveCategory(scrollY) {
        var activeCategoryId = this.getActiveCategory(scrollY);
        if (this.state.activeCategoryId !== activeCategoryId) {
            return true;
        }
        return false;
    };
    _proto.checkActiveCategory = function checkActiveCategory(scrollY) {
        if (this.shouldUpdateActiveCategory(scrollY)) {
            var activeCategoryId = this.getActiveCategory(scrollY);
            this.setState({
                activeCategoryId: activeCategoryId
            });
        }
    };
    _proto.getActiveCategory = function getActiveCategory(scrollY) {
        if (!this.props.categories) return;
        var activeCategoryId = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _step.value, categoryId = _value._id;
                var element = this.categoriesRefs[categoryId];
                if (!element) continue;
                var position = element.offsetTop;
                if (position - this.getCategoriesBarOffset() - 10 < scrollY) {
                    activeCategoryId = categoryId;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return activeCategoryId;
    };
    _proto.getSelectedProduct = function getSelectedProduct() {
        if (!this.props.categories) return null;
        var productId = this.lastProductId || this.props.router.query.productId;
        if (!productId) return null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var products = _step.value.products;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var product = _step1.value;
                        if (product._id === productId) {
                            return product;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.renderCategories = function renderCategories() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var categories = this.getVisibleCategories();
        var lastBrandId = null;
        var isMultiBrand = this.props.website.isMultiBrand;
        return categories.map(function(category) {
            var _this1 = _this;
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var dividerContent = !category.brand && lastBrandId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoBrandDivider/* default */.Z, {}) : null;
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar/* default */.Z, {
                brand: brand
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    isMultiBrand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            brandContent,
                            dividerContent
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(ref) {
                            return _this1.categoriesRefs[category._id] = ref;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {
                            productsLayout: _this.props.productsLayout,
                            layout: _this.props.layout,
                            productCardDesign: _this.props.productCardDesign,
                            category: category,
                            menuId: _this.props.menuId,
                            hidePrice: _this.props.preferences.shouldHidePrice,
                            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                            select: function(select) {
                                return _this1.setState({
                                    select: select,
                                    open: true
                                });
                            },
                            sorting: _this.state.sorting,
                            hideNotAvailableProducts: _this.props.website.hideNotAvailableProducts
                        })
                    })
                ]
            }, category._id);
        });
    };
    _proto.renderSelect = function renderSelect() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct/* default */.Z, {
                product: this.getSelectedProduct(),
                storeId: this.props.storeId,
                open: !!(this.props.router.query.productId && this.getSelectedProduct()),
                menuId: this.props.preferences.menuId,
                preferences: this.props.preferences,
                close: function() {
                    var query = _objectSpread({}, (0,getQueryObject/* default */.Z)(_this.props.router));
                    delete query.productId;
                    _this.props.router.push({
                        pathname: (0,getOrderPath/* default */.Z)(_this.props.router, _this.props.website),
                        query: query
                    }, null, {
                        scroll: false
                    });
                }
            })
        });
    };
    _proto.renderBar = function renderBar() {
        var _this = this;
        var visibleCategories = this.getVisibleCategories();
        if (!visibleCategories.length) return;
        return this.props.website && this.props.website.isMultiBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Brands/* default */.Z, {
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo3) {
                return _this.setState({
                    scrollTo: scrollTo3,
                    scrollOffset: 120
                });
            },
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories/* default */.Z, {
            activeCategoryId: this.state.activeCategoryId,
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo4) {
                return _this.setState({
                    scrollTo: scrollTo4
                });
            },
            layout: this.props.layout,
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        });
    };
    _proto.memoizeProducts = function memoizeProducts() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1, categories, Fuse, allProducts, searchProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        categories = (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1.items;
                        if (!(!categories || categories.length === 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return __webpack_require__.e(/* import() */ 4221).then(__webpack_require__.bind(__webpack_require__, 74221));
                    case 6:
                        Fuse = _ctx.sent.default;
                        allProducts = uniqBy_default()(flatten_default()(categories.map(function(cat) {
                            return cat.products;
                        })), "_id");
                        searchProducts = getProducts(allProducts, _this.state.filter, Fuse, _this.state.sorting);
                        if (!(searchProducts.length === 0)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        _this.setState({
                            searchProducts: searchProducts
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderSearchResults = function renderSearchResults() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var category = {
            _id: "search",
            name: "Resultados",
            products: this.state.searchProducts
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {
            productsLayout: this.props.productsLayout,
            layout: this.props.layout,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            category: category,
            menuId: this.props.menuId,
            hidePrice: this.props.preferences.shouldHidePrice,
            select: function(select) {
                return _this.setState({
                    select: select,
                    open: true
                });
            },
            productCardDesign: this.props.productCardDesign,
            sorting: this.state.sorting
        });
    };
    _proto.render = function render() {
        var _this = this;
        var productId = this.props.router.query.productId;
        if (productId) {
            this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        var products = this.state.filter ? this.renderSearchResults() : this.renderCategories();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).container + " " + (styles_module_default())["container_" + this.props.layout],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* default */.Z, {
                        layout: this.props.layout,
                        filter: this.state.filter,
                        setFilter: function(filter) {
                            _this.setState({
                                filter: filter
                            });
                            if (filter) {
                                _this.memoizeProducts();
                            }
                        },
                        children: this.renderBar()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: (styles_module_default()).containerWebsiteCoins,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoins/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (styles_module_default()).containerLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).containerIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                                preferences: this.props.preferences,
                                website: this.props.website,
                                isOnMenu: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).containerFilter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* default */.Z, {
                                    sorting: this.state.sorting,
                                    setSorting: function(sorting) {
                                        return _this.setState({
                                            sorting: sorting
                                        });
                                    }
                                })
                            })
                        })
                    ]
                }),
                this.props.layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        this.props.nextOpenDate,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        products
                    ]
                }) : products,
                this.renderSelect()
            ]
        });
    };
    return ProductsContent;
}(react.Component)) || _class) || _class) || _class) || _class;
/* harmony default export */ var Products_ProductsContent = ((0,router.withRouter)(ProductsContent));

// EXTERNAL MODULE: ./src/data/fragments/categories/orderCategory.main.ts
var orderCategory_main = __webpack_require__(13219);
// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/categories/categoriesForWebsite.main.ts
function categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function categoriesForWebsite_main_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCategoriesAndProductsWeb_cached(\n    $websiteId: ID\n    $menuId: ID\n    $format: String\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        ...orderCategory\n        brand {\n          _id\n          name\n          link\n          menuImage {\n            _id\n            url\n          }\n          categoriesImage {\n            _id\n            url\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var categoriesForRestaurantQuery = (0,lib["default"])(_templateObject(), orderCategory_main/* default */.Z);
function getCategoriesForWebsite(_) {
    return _getCategoriesForWebsite.apply(this, arguments);
}
function _getCategoriesForWebsite() {
    _getCategoriesForWebsite = categoriesForWebsite_main_asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var websiteId, menuId, _format, format, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    websiteId = param.websiteId, menuId = param.menuId, _format = param.format, format = _format === void 0 ? "webp" : _format;
                    _ctx.next = 3;
                    return getClient().query({
                        query: categoriesForRestaurantQuery,
                        variables: {
                            websiteId: websiteId,
                            menuId: menuId,
                            format: format
                        }
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.categories);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCategoriesForWebsite.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useCategoriesAndProducts.ts



function useCategoriesAndProducts(param) {
    var websiteId = param.websiteId, menuId = param.menuId, format = param.format, _preloadedCategories = param.preloadedCategories, preloadedCategories = _preloadedCategories === void 0 ? {
        items: []
    } : _preloadedCategories, storeId = param.storeId, deliverAt = param.deliverAt;
    // On the serverside, we skip this query and return the categories loaded at getStaticProps
    // These categories are obtained from the store default menu
    var result = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: categoriesForRestaurantQuery,
        variables: {
            websiteId: websiteId,
            menuId: menuId,
            format: format,
            storeId: storeId,
            deliverAt: deliverAt
        },
        omit: (0,isServerSide/* default */.Z)()
    });
    if ((0,isServerSide/* default */.Z)() || !result.data) {
        return {
            categories: preloadedCategories
        };
    }
    return result;
};

// EXTERNAL MODULE: ./src/data/queries/stock/getOutOfStockProductsInList.ts
var getOutOfStockProductsInList = __webpack_require__(74207);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useSetOutOfStockProducts.ts




function useSetOutOfStockProducts(param) {
    var websiteId = param.websiteId, categories = param.categories, storeId = param.storeId, deliverAt = param.deliverAt;
    var productsIds = [];
    var cats = categories ? categories.items : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = category.products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var product = _step1.value;
                    productsIds.push(product._id);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var outOfStockIds = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getOutOfStockProductsInList/* getOutOfStockProductsInListQuery */.q,
        variables: {
            websiteId: websiteId,
            productsIds: uniq_default()(productsIds),
            storeId: storeId,
            deliverAt: deliverAt
        },
        partial: true,
        omit: productsIds.length === 0 || !storeId || (0,isServerSide/* default */.Z)()
    }).outOfStockIds;
    if (!outOfStockIds || !outOfStockIds.length) return {
        outOfStockIds: []
    };
    return {
        outOfStockIds: outOfStockIds
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/index.tsx
function Products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var ProductsContentMemo = /*#__PURE__*/ react.memo(Products_ProductsContent);
function Products(props) {
    var menuId = props.menuId, storeId = props.storeId, deliverAt = props.deliverAt, preloadedCategories = props.preloadedCategories, website = props.website;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var format = (0,hasWebpSupport/* default */.Z)() ? "webp" : "jpeg";
    var categories = useCategoriesAndProducts({
        websiteId: websiteId,
        menuId: menuId,
        format: format,
        preloadedCategories: preloadedCategories,
        storeId: storeId,
        deliverAt: deliverAt
    }).categories;
    /**
   * TODO: Reverted changed from nicoleguerrero/ep-1039 because the main query is cached,
   * so a change in the stock is not reflected automatically en the query.
   * It is needed to separate the query in the stable values (cached) and the dynamic ones (non cached)
   * before deleting this logic
   * cc Niko
   */ var outOfStockIds = useSetOutOfStockProducts({
        websiteId: websiteId,
        categories: categories,
        storeId: storeId,
        deliverAt: deliverAt
    }).outOfStockIds;
    var memoizedCategories = (0,react.useMemo)(function() {
        if (!((categories === null || categories === void 0 ? void 0 : categories.items) && outOfStockIds)) return categories;
        var newCategories = {
            items: []
        };
        newCategories.items = categories.items.map(function(category) {
            var newProducts = category.products.map(function(product) {
                return Products_objectSpread({}, product, {
                    isOutOfStock: outOfStockIds.includes(product._id)
                });
            });
            return Products_objectSpread({}, category, {
                products: newProducts
            });
        });
        return newCategories;
    }, [
        outOfStockIds,
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContentMemo, Products_objectSpread({}, props, {
        website: website,
        categories: memoizedCategories
    }));
};


/***/ }),

/***/ 80449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1h-aTgBjS9DnZxzvM-1N7w buttonShadow","icon":"m_RU5JotN4Jf9e-3gF3k","menuText":"_1uEIw5iXXaEhyWSG8QUUYB","menu":"lNxYI4NR0QXxUWpnkyzxG","account":"_2zN3KfL4DCAbiftdxv0WNT","name":"_36ixizDnhORbr-aHEfUQ7P","email":"_3xWt_t5piTol1xnIjIvXcI","menuLink":"_3jzCLpKIXuvIoz3TbBYXlh","divider":"Wrt-TFXAQAWTuMepYhXAC","logoutIcons":"_151yV5--gPTRNYM2th9W0c","user-menu-enter":"HxETBatahehao0Y8Bt6bB","user-menu-leave":"vQTRR_0XKJ20XD7Qmvvil","user-menu-leave-active":"_2jW3MvouCN3e8b65lNYhc","user-menu-enter-active":"_3eVYUg38RO2e4sWayZwayu"};

/***/ }),

/***/ 59540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jU7LHQAFgsjy0t2QSVFUG","name":"fahAOBEtcJXL_vQiK4fah appTitle","products":"Jw-GQ1r-mZqgls-nIWFlc","menuProductCol":"_2gA2q6LFKNg_089WQ7zI7k"};

/***/ }),

/***/ 31616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MGVMHYuV2u5Mnd4iJrB5z","order":"_1rc5Zr7uGJ08A7khxcq_Cw","container_v2":"_3FD032u_YFLQKVcG3ziO6E","containerIcon":"_2Oh-2Bzj3YvGTCi-dCDB8E","containerWebsiteCoins":"_25miMneexJVc-xJkhJkBJ","containerLabel":"VCCkn5d7s1AgefhPPUSFA","containerFilter":"_4k1tbxlHpljsPDTqQ7AH4"};

/***/ })

}]);